<template>
  <div class="header" v-if="!isMobile">
    <div class="upperHead">
      <div class="leftUpperHead">
        <div class="logoHeader">
          <a href="/"><img src="../assets/icons/logo.svg" /></a>
        </div>
        <div class="searchBlock">
          <input
            type="text"
            v-model="searchInput"
            @keyup.enter="searchEnter"
            placeholder="Имя, описание"
          />
          <button @click="searchWhore"><img src="../assets/icons/zoom.svg" /></button>
        </div>
      </div>
      <div class="rightUpperHead">
        <div class="authSection" v-if="user == null && allowRegistration">
          <button class="signIn" @click="openAuth">Войти</button>
          <button class="signUp" @click="openAuth">Зарегистрироваться</button>
          <Transition name="fade">
            <AuthComponent v-if="authOpen" @close-auth="openAuth" :modeParent="methodAuth" />
          </Transition>
        </div>
        <div class="notificationsDropdown" v-if="user">
          <button class="notificationButton" @click="toggleNotifications">
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 4C8.68629 4 6 6.68629 6 10V12.7639C6 13.5215 5.78528 14.2637 5.38197 14.905L4.17669 16.8216C3.76535 17.4753 4.23519 18.3333 5.00767 18.3333H18.9923C19.7648 18.3333 20.2346 17.4753 19.8233 16.8216L18.618 14.905C18.2147 14.2637 18 13.5215 18 12.7639V10C18 6.68629 15.3137 4 12 4Z"
                stroke="currentColor"
                stroke-width="1.8"
              />
              <path
                d="M10 20C10.4587 20.6078 11.185 21 12 21C12.815 21 13.5413 20.6078 14 20"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
              />
              <path d="M12 3V4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
            </svg>
            <span class="notificationBadge" v-if="unreadNotificationsCount"></span>
          </button>
          <Transition name="fade">
            <div
              class="notificationsList"
              v-click-outside="closeNotifications"
              v-show="showNotifications"
            >
              <p>Уведомления</p>
              <div class="notificationsState" v-if="notificationsLoading">Загрузка...</div>
              <div class="notificationsState" v-else-if="!notifications.length">
                Пока уведомлений нет
              </div>
              <ul v-else>
                <li
                  v-for="notification in notifications"
                  :key="
                    notification._id ||
                    notification.id ||
                    notification.createdAt ||
                    notification.title
                  "
                >
                  <div class="notificationIcon">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 4C8.68629 4 6 6.68629 6 10V12.7639C6 13.5215 5.78528 14.2637 5.38197 14.905L4.17669 16.8216C3.76535 17.4753 4.23519 18.3333 5.00767 18.3333H18.9923C19.7648 18.3333 20.2346 17.4753 19.8233 16.8216L18.618 14.905C18.2147 14.2637 18 13.5215 18 12.7639V10C18 6.68629 15.3137 4 12 4Z"
                        stroke="currentColor"
                        stroke-width="1.8"
                      />
                      <path
                        d="M10 20C10.4587 20.6078 11.185 21 12 21C12.815 21 13.5413 20.6078 14 20"
                        stroke="currentColor"
                        stroke-width="1.8"
                        stroke-linecap="round"
                      />
                      <path
                        d="M12 3V4"
                        stroke="currentColor"
                        stroke-width="1.8"
                        stroke-linecap="round"
                      />
                    </svg>
                  </div>
                  <div class="notificationContent">
                    <p class="notificationTitle">
                      {{
                        notification.title ||
                        notification.header ||
                        notification.name ||
                        "Уведомление"
                      }}
                    </p>
                    <p class="notificationText">
                      {{
                        notification.text ||
                        notification.message ||
                        notification.description ||
                        "Без описания"
                      }}
                    </p>
                    <span
                      class="notificationDate"
                      v-if="notification.createdAt || notification.date"
                      >{{
                        formatNotificationDate(notification.createdAt || notification.date)
                      }}</span
                    >
                  </div>
                </li>
              </ul>
            </div>
          </Transition>
        </div>
        <a href="/profile" v-if="user">
          <div class="profileSection">
            <img src="../assets/icons/userProfile.svg" />
            <div class="userInfo">
              <p class="userInfoName">
                {{ user.login.length > 6 ? user.login.substring(0, 6) + "..." : user.login }}
              </p>
              <p class="userInfoID">id{{ user.numId }}</p>
            </div>
          </div>
        </a>
        <button class="mainMenu" @click="openMainMenu">
          <svg
            width="20"
            height="9"
            viewBox="0 0 20 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="!mainOpen"
          >
            <path d="M1 8H19" stroke="white" stroke-width="2" stroke-linecap="round" />
            <path d="M1 1H19" stroke="white" stroke-width="2" stroke-linecap="round" />
          </svg>
          <img src="../assets/icons/crossClose.svg" width="20px" height="15px" v-else />
        </button>
        <Transition name="fade">
          <MainMenu v-if="mainOpen" />
        </Transition>
      </div>
    </div>
    <div class="lowerHead">
      <ul class="headerCategories">
        <a :href="this.user != null ? '/girls/1?premium=1' : null" @click="openAuth"
          ><li>Премиум</li></a
        >
        <a :href="this.user != null ? '/girls/1?elite=1' : null" @click="openAuth"
          ><li>Элитные</li></a
        >
        <a :href="this.user != null ? '/girls/1?individual=1' : null" @click="openAuth"
          ><li>Индивидуалки</li></a
        >
        <a :href="this.user != null ? '/girls/1?slut=1' : null" @click="openAuth"
          ><li>Проститутки</li></a
        >
        <a :href="this.user != null ? '/girls/1?massage=1' : null" @click="openAuth"
          ><li>Массажистки</li></a
        >
      </ul>
      <div
        class="cityDropdown"
        v-if="!this.$store.getters.getUserData || this.$store.getters.getUserData.cityId"
      >
        <div class="geoLocation" @click="showCityListClick">
          <img src="../assets/icons/geo.svg" />
          <p>{{ city }}</p>
        </div>
        <Transition name="fade">
          <div
            class="cityList"
            v-click-outside="closeCityList"
            v-show="showCityList"
            :style="cityListStyle"
          >
            <p>Города России</p>
            <ul>
              <li v-for="city in cityList" v-bind:key="city" @click="changeCity">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="14" height="14" rx="3" fill="#F3F3F3" />
                </svg>
                {{ city }}
              </li>
            </ul>
          </div>
        </Transition>
      </div>
    </div>
  </div>

  <div class="mobileHeader">
    <div class="upperHead">
      <div class="leftUpperHead">
        <button class="mainMenu" @click="openMainMenu">
          <svg
            width="20"
            height="9"
            viewBox="0 0 20 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-if="!mainOpen"
          >
            <path d="M1 8H19" stroke="white" stroke-width="2" stroke-linecap="round" />
            <path d="M1 1H19" stroke="white" stroke-width="2" stroke-linecap="round" />
          </svg>
          <img src="../assets/icons/crossClose.svg" width="20px" height="15px" v-else />
        </button>
        <Transition name="fade">
          <MainMenu v-if="mainOpen" />
        </Transition>
        <div class="logoHeader">
          <a href="/"><img src="../assets/icons/logo.svg" /></a>
        </div>
        <div class="mobileSearchBlock" ref="mobileSearchBlock">
          <input
            type="text"
            v-model="searchInput"
            @keyup.enter="searchEnter"
            placeholder="Имя, описание"
          />
          <button @click="searchWhore">
            <img src="../assets/icons/zoom.svg" @click="toggleSearch" />
          </button>
        </div>
        <div class="mobileAuthBlock">
          <div class="mobileAuthSection" v-if="user == null && mainOpen && allowRegistration">
            <button class="signUp" @click="openAuthMobile">Зарегистрироваться</button>
            <button class="signIn" @click="openAuthMobile">Войти</button>
            <Transition name="fade">
              <AuthComponent v-if="authOpen" @close-auth="openAuth" :modeParent="methodAuth" />
            </Transition>
          </div>
          <div class="mobileNotificationsDropdown" v-if="user != null && mainOpen">
            <button
              class="notificationButton mobileNotificationButton"
              @click="toggleNotifications"
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 4C8.68629 4 6 6.68629 6 10V12.7639C6 13.5215 5.78528 14.2637 5.38197 14.905L4.17669 16.8216C3.76535 17.4753 4.23519 18.3333 5.00767 18.3333H18.9923C19.7648 18.3333 20.2346 17.4753 19.8233 16.8216L18.618 14.905C18.2147 14.2637 18 13.5215 18 12.7639V10C18 6.68629 15.3137 4 12 4Z"
                  stroke="currentColor"
                  stroke-width="1.8"
                />
                <path
                  d="M10 20C10.4587 20.6078 11.185 21 12 21C12.815 21 13.5413 20.6078 14 20"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                />
                <path d="M12 3V4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
              </svg>
              <span class="notificationBadge" v-if="unreadNotificationsCount"></span>
            </button>
            <Transition name="fade">
              <div
                class="notificationsList mobileNotificationsList"
                v-click-outside="closeNotifications"
                v-show="showNotifications"
              >
                <p>Уведомления</p>
                <div class="notificationsState" v-if="notificationsLoading">Загрузка...</div>
                <div class="notificationsState" v-else-if="!notifications.length">
                  Пока уведомлений нет
                </div>
                <ul v-else>
                  <li
                    v-for="notification in notifications"
                    :key="
                      notification._id ||
                      notification.id ||
                      notification.createdAt ||
                      notification.title
                    "
                  >
                    <div class="notificationIcon">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 4C8.68629 4 6 6.68629 6 10V12.7639C6 13.5215 5.78528 14.2637 5.38197 14.905L4.17669 16.8216C3.76535 17.4753 4.23519 18.3333 5.00767 18.3333H18.9923C19.7648 18.3333 20.2346 17.4753 19.8233 16.8216L18.618 14.905C18.2147 14.2637 18 13.5215 18 12.7639V10C18 6.68629 15.3137 4 12 4Z"
                          stroke="currentColor"
                          stroke-width="1.8"
                        />
                        <path
                          d="M10 20C10.4587 20.6078 11.185 21 12 21C12.815 21 13.5413 20.6078 14 20"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                        />
                        <path
                          d="M12 3V4"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                        />
                      </svg>
                    </div>
                    <div class="notificationContent">
                      <p class="notificationTitle">
                        {{
                          notification.title ||
                          notification.header ||
                          notification.name ||
                          "Уведомление"
                        }}
                      </p>
                      <p class="notificationText">
                        {{
                          notification.text ||
                          notification.message ||
                          notification.description ||
                          "Без описания"
                        }}
                      </p>
                      <span
                        class="notificationDate"
                        v-if="notification.createdAt || notification.date"
                        >{{
                          formatNotificationDate(notification.createdAt || notification.date)
                        }}</span
                      >
                    </div>
                  </li>
                </ul>
              </div>
            </Transition>
          </div>
          <a href="/profile" v-if="user != null && mainOpen">
            <div class="profileSection">
              <img src="../assets/icons/userProfile.svg" />
              <div class="userInfo">
                <p class="userInfoName">
                  {{ user.login.length > 6 ? user.login.substring(0, 6) + "..." : user.login }}
                </p>
                <p class="userInfoID">id{{ user.numId }}</p>
              </div>
            </div>
          </a>
        </div>
      </div>
      <!-- <div class="mobileRightUpperHead" v-if="mainOpen">
        <div class="mobileAuthSection" v-if="user == null">
          <button class="signUp" @click="openAuth">Зарегистрироваться</button>
          <button class="signIn" @click="openAuth">Войти</button>
          <Transition name="fade">
            <AuthComponent v-if="authOpen" @close-auth="openAuth" :modeParent="methodAuth" />
          </Transition>
        </div>
        <a href="/profile" v-else>
          <div class="profileSection">
            <img src="../assets/icons/userProfile.svg" />
            <div class="userInfo">
              <p class="userInfoName">{{ user.login }}</p>
              <p class="userInfoID">id{{ user.numId }}</p>
            </div>
          </div>
        </a>
      </div> -->
    </div>
    <div class="lowerHead" v-if="mainOpen">
      <div class="cityDropdown">
        <div class="geoLocation" @click="showCityListClick">
          <svg
            width="14"
            height="20"
            viewBox="0 0 14 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.43319 17.173C11.4542 14.5958 14 10.8515 14 8.34271C14 4.18257 10.866 0.810104 7 0.810104C3.13401 0.810104 0 4.18257 0 8.34271C0 10.8515 2.54577 14.5958 4.56681 17.173C5.62122 18.5176 6.14842 19.1899 7 19.1899C7.85158 19.1899 8.37879 18.5176 9.43319 17.173ZM7 11.3101C5.55025 11.3101 4.375 10.1349 4.375 8.6851C4.375 7.23536 5.55025 6.0601 7 6.0601C8.44975 6.0601 9.625 7.23536 9.625 8.6851C9.625 10.1349 8.44975 11.3101 7 11.3101Z"
              fill="#FFFFFF"
            />
          </svg>
          <p>{{ city }}</p>
        </div>
        <Transition name="fade">
          <div
            class="cityList"
            v-click-outside="closeCityList"
            v-show="showCityList"
            :style="cityListStyle"
          >
            <p>Города России</p>
            <div style="overflow: auto; height: 90%">
              <ul>
                <li v-for="city in cityList" v-bind:key="city" @click="changeCity">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="14" height="14" rx="3" fill="#F3F3F3" />
                  </svg>
                  {{ city }}
                </li>
              </ul>
            </div>
          </div>
        </Transition>
      </div>
    </div>
  </div>
  <ul class="headerCategories" v-if="isMobile">
    <a :href="this.user != null ? '/girls/1?premium=1' : null" @click="openAuth"
      ><li>Премиум</li></a
    >
    <a :href="this.user != null ? '/girls/1?elite=1' : null" @click="openAuth"><li>Элитные</li></a>
    <a :href="this.user != null ? '/girls/1?individual=1' : null" @click="openAuth"
      ><li>Индивидуалки</li></a
    >
    <a :href="this.user != null ? '/girls/1?slut=1' : null" @click="openAuth"
      ><li>Проститутки</li></a
    >
    <a :href="this.user != null ? '/girls/1?massage=1' : null" @click="openAuth"
      ><li>Массажистки</li></a
    >
  </ul>
</template>

<script>
import clickOutside from "@/directives/click-outside";
import axios from "axios";
import AuthComponent from "./AuthComponent.vue";
import MainMenu from "./MainMenu.vue";
import { useToast } from "vue-toastification";

export default {
  name: "HeaderComponent",
  data() {
    return {
      mainOpen: false,
      authOpen: false,
      methodAuth: "signIn",
      searchInput: "",
      showCityList: false,
      showNotifications: false,
      cityListStyle: {},
      user: null,
      city: null,
      cityList: [],
      notifications: [],
      notificationsLoading: false,
      isMobile: false,
      isSearchOpen: false,
      mirrorInfo: null,
      // allowRegistration: this.$store.state.allowRegistration,
      allowRegistration: true,
    };
  },
  components: {
    MainMenu,
    AuthComponent,
  },
  directives: {
    clickOutside,
  },
  computed: {
    unreadNotificationsCount() {
      return this.notifications.filter((notification) => !notification.read).length;
    },
  },
  methods: {
    async openMainMenu() {
      let body = document.querySelector("body");
      let button;
      if (window.innerWidth < 968)
        button = document.querySelector(".mobileHeader .upperHead .leftUpperHead .mainMenu");
      else button = document.querySelector(".mainMenu");
      console.log(button);
      if (this.mainOpen) {
        this.mainOpen = false;
        body.style.position = "";
        body.style.overflowY = "";
        // await nextTick()
        button.style.backgroundColor = "";
      } else {
        this.mainOpen = true;
        body.style.overflowY = "scroll";
        body.style.position = "fixed";
        // await nextTick()
        button.style.backgroundColor = "#FFFFFF";
        // let authButtons = document.querySelectorAll(".authSection")
        // console.log(authButtons)
        // authButtons.style.display = "flex"
      }
    },
    normalizeNotifications(data) {
      if (Array.isArray(data)) return data;
      if (Array.isArray(data?.data)) return data.data;
      if (Array.isArray(data?.items)) return data.items;
      if (Array.isArray(data?.notifications)) return data.notifications;
      return [];
    },
    getReadNotificationsStorageKey() {
      const userId = this.$store.getters.getUserData?._id || "guest";
      return `read-notifications:${userId}`;
    },
    getReadNotificationIds() {
      try {
        const rawValue = localStorage.getItem(this.getReadNotificationsStorageKey());
        const parsedValue = rawValue ? JSON.parse(rawValue) : [];
        return Array.isArray(parsedValue) ? parsedValue : [];
      } catch {
        return [];
      }
    },
    applyReadNotifications(notifications) {
      const readNotificationIds = new Set(this.getReadNotificationIds());
      return notifications.map((notification) => ({
        ...notification,
        read:
          notification.read ||
          readNotificationIds.has(String(notification._id || notification.id || "")),
      }));
    },
    persistReadNotifications() {
      try {
        const readNotificationIds = this.notifications
          .filter((notification) => notification.read)
          .map((notification) => String(notification._id || notification.id || ""))
          .filter(Boolean);

        localStorage.setItem(
          this.getReadNotificationsStorageKey(),
          JSON.stringify(readNotificationIds),
        );
      } catch {
        // ignore localStorage write errors
      }
    },
    async loadNotifications() {
      if (!this.$store.state.userData?.token) return;

      this.notificationsLoading = true;
      try {
        const res = await axios.get(`https://${process.env.VUE_APP_SERVERHOST}/api/notification`, {
          params: {
            offset: 0,
            count: 20,
          },
          headers: {
            Authorization: "Bearer " + this.$store.state.userData.token,
          },
        });
        this.notifications = this.applyReadNotifications(
          this.normalizeNotifications(res.data?.result ?? res.data),
        );
      } catch (err) {
        this.notifications = [];
        console.log(err);
      } finally {
        this.notificationsLoading = false;
      }
    },
    async toggleNotifications() {
      this.showNotifications = !this.showNotifications;
      if (this.showNotifications && !this.notifications.length && !this.notificationsLoading) {
        await this.loadNotifications();
      }
      if (this.showNotifications) {
        this.notifications = this.notifications.map((notification) => ({
          ...notification,
          read: true,
        }));
        this.persistReadNotifications();
      }
    },
    closeNotifications(event) {
      if (
        !event.target.closest(".notificationButton") &&
        !event.target.closest(".notificationsList")
      ) {
        this.showNotifications = false;
      }
    },
    handleIncomingNotification(event) {
      const notification = event.detail?.data ?? event.detail;
      if (!notification) return;

      const notificationId = notification._id || notification.id;
      const hasNotification = this.notifications.some(
        (item) => String(item._id || item.id || "") === String(notificationId || ""),
      );

      if (hasNotification) return;

      this.notifications = [
        {
          ...notification,
          read: false,
        },
        ...this.notifications,
      ];
    },
    formatNotificationDate(value) {
      if (!value) return "";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "";
      return date.toLocaleString("ru-RU", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    searchEnter() {
      this.searchWhore();
    },
    toggleSearch() {
      if (this.user) {
        this.isSearchOpen = !this.isSearchOpen;
        const searchBlock = this.$refs.mobileSearchBlock;
        if (searchBlock) {
          searchBlock.classList.toggle("active", this.isSearchOpen);
        }
      }
    },
    searchWhore() {
      if (!this.user) this.openAuth();
      if (this.searchInput && this.user) window.location.href = `/search/${this.searchInput}/1`;
    },
    openMainFromMain() {
      this.openMainMenu();
      this.openAuth();
    },
    async openAuthMobile(event) {
      this.authOpen = true;
      try {
        this.methodAuth = event.target.className + "Select";
        if (!event.target.className) this.methodAuth = "signInSelect";
      } catch {
        this.methodAuth = "signInSelect";
      }
      if (this.isMobile) {
        await this.$nextTick();
        let geo = document.querySelector(".lowerHead .geoLocation");
        let cross = document.querySelector(".mainMenu");
        geo.style.display = "none";
        cross.style.display = "none";
      }
    },
    async openAuth(event) {
      await this.$nextTick();
      if (this.user == null) {
        let geo = document.querySelector(".lowerHead .geoLocation");
        let cross = document.querySelector(".mainMenu");
        // let body = document.querySelector("body");
        if (this.authOpen) {
          this.authOpen = false;
          geo.style.display = "flex";
          cross.style.display = "flex";
          // body.style.overflowY = "";
        } else {
          try {
            this.methodAuth = event.target.className + "Select";
            if (!event.target.className) this.methodAuth = "signInSelect";
          } catch {
            this.methodAuth = "signInSelect";
          }
          this.authOpen = true;
          if (this.isMobile) {
            this.openMainMenu();
            await this.$nextTick();
            let geo = document.querySelector(".lowerHead .geoLocation");
            let cross = document.querySelector(".mainMenu");
            geo.style.display = "none";
            cross.style.display = "none";
          }
          // body.style.overflowY = "scroll";

          console.log(this.methodAuth);
        }
      }
    },
    loadUserData() {
      this.user = this.$store.getters.getUserData;
      axios
        .get(`https://${process.env.VUE_APP_SERVERHOST}/api/public/cities`, {
          headers: {
            Authorization: "Bearer " + this.$store.state.userData.token,
          },
        })
        .then((res) => {
          this.cityList = res.data.result.map((item) => item.name);
        })
        .catch((err) => {
          console.log(err);
        });
      this.loadNotifications();
    },
    closeCityList(event) {
      if (!event.target.closest(".geoLocation")) this.showCityList = false;
      // console.log("КЛИК ВНЕ ГОРОДА", event.target)
    },
    getMirrorInfo() {
      axios
        .get(`https://${process.env.VUE_APP_SERVERHOST}/api/mirror/`)
        .then((res) => {
          this.mirrorInfo = res.data;
          this.$store.commit("setAllowRegistration", res.data.result.allow_registration);
          // this.allowRegistration = this.$store.getters.getAllowRegistration;
          this.allowRegistration = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeCity(event) {
      let e = event.target.closest("li");
      this.city = e.innerText;
      axios
        .put(
          `https://${process.env.VUE_APP_SERVERHOST}/api/users/city`,
          {
            cityName: this.city,
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.userData.token,
            },
          },
        )
        .then(() => {
          let e = event.target.closest("li");
          let list = document.querySelectorAll(".cityList ul li svg rect");
          for (let l of list) l.style.fill = "#F3F3F3";
          this.city = e.innerText;
          e.children[0].children[0].style.fill = "#FF8989";
          this.$store.commit("setCity", e.innerText);
          window.location.href = "/";
        })
        .catch((err) => {
          console.log(err);
          this.toast.error(err.response.data.message);
        });
    },
    showCityListClick(event) {
      if (this.$store.getters.getUserData != null) {
        const trigger = event?.currentTarget;
        if (trigger) {
          const width = Math.min(window.innerWidth * 0.8, 340);
          const rect = trigger.getBoundingClientRect();
          const left = Math.min(Math.max(16, rect.right - width), window.innerWidth - width - 16);

          this.cityListStyle = {
            top: `${rect.bottom + 12}px`,
            left: `${left}px`,
            width: `${width}px`,
          };
        }
        this.showCityList = true;
        let el = document.querySelectorAll(".cityList ul li");
        setTimeout(() => {
          for (let e of el) {
            if (e.innerText == this.city) {
              let list = document.querySelectorAll(".cityList ul li svg rect");
              for (let l of list) l.style.fill = "#F3F3F3";
              e.children[0].children[0].style.fill = "#FF8989";
              break;
            }
          }
        }, 10);
      } else this.openAuth();
    },
  },
  mounted() {
    this.city = this.$store.getters.getCity;
    if (this.$store.getters.getUserData != null) this.loadUserData();
    this.isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    this.getMirrorInfo();
    window.addEventListener("escort:notification", this.handleIncomingNotification);
  },
  beforeUnmount() {
    window.removeEventListener("escort:notification", this.handleIncomingNotification);
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
};
</script>
<style scoped>
.header {
  background-color: #f6fafd;
  padding-left: 18vw;
  padding-right: 18vw;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #333333;
  display: flex;
  flex-direction: column;
  gap: 20px;
  border-radius: 0 0 30px 30px;
  overflow: visible;
}
.mobileHeader {
  background-color: #f6fafd;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #333333;
  display: none;
  flex-direction: column;
  gap: 20px;
  border-radius: 0 0 30px 30px;
  overflow: visible;
}
.upperHead {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 5%;
}
.leftUpperHead {
  justify-self: left;
  display: flex;
  gap: 40px;
  align-items: center;
}
.logoHeader {
  width: 100%;
  display: flex;
  align-items: center;
}
.logoHeader img {
  cursor: pointer;
}
.rightUpperHead {
  justify-self: right;
  display: flex;
  gap: 10px;
  align-items: center;
}
.mobileRightUpperHead {
  justify-self: right;
  display: flex;
  gap: 10px;
  z-index: 5001;
}
.searchBlock {
  display: flex;
  gap: 10px;
  width: 70%;
  justify-self: right;
}
.searchBlock input {
  background-color: #ffffff;
  border: 1px solid #e2e2e2;
  border-radius: 10px;
  width: 20vw;
  padding: 10px;
  outline: none;
  padding: 3% 5% 3% 5%;
}
.searchBlock button {
  background-color: #2f2f2f;
  border: 1px solid #2f2f2f;
  border-radius: 10px;
  padding: 10px 12px 10px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.mobileSearchBlock {
  position: absolute; /* Абсолютное позиционирование, чтобы не мешать остальным блокам */
  top: 0;
  right: 0; /* Позиционируем его в правом верхнем углу */
  transition: width 0.3s ease;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.mobileSearchBlock.active {
  background-color: #2f2f2f;
  border-radius: 10px;
  padding-left: 10px;
}
.mobileSearchBlock input {
  width: 0; /* Изначально скрыто */
  opacity: 0;
  background-color: #393939;
  color: #ffffffb2;
  font-size: 12px;
  border: 1px solid transparent;
  border-radius: 10px;
  padding: 3%;
  transition: width 0.3s ease, opacity 0.3s ease;
}
.mobileSearchBlock.active input {
  width: 50vw; /* Ввод теперь будет виден */
  opacity: 1;
}
.mobileSearchBlock button {
  background-color: #2f2f2f;
  border: 1px solid #2f2f2f;
  border-radius: 10px;
  padding: 10px 12px 10px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 52px;
  height: 50px;
  justify-content: center;
}
.mobileSearchBlock input:focus {
  outline: none;
}
.mobileAuthBlock {
  position: absolute;
  z-index: 5000;
  right: 0;
  width: 50%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}
.signIn {
  background-color: transparent;
  border: 1px solid #494949;
  border-radius: 10px;
  font-weight: 600;
  padding: 13px 40px 13px 40px;
  cursor: pointer;
}
.signUp {
  background-color: #ff8989;
  border-radius: 10px;
  border: 1px solid transparent;
  color: white;
  font-weight: 600;
  padding: 13px 40px 13px 40px;
  cursor: pointer;
}
.authSection {
  gap: 10px;
  display: flex;
}
.mobileAuthSection {
  gap: 10px;
  display: flex;
}
.profileSection {
  padding: 5px 10px 5px 10px;
  background-color: #ffffff;
  border-radius: 10px;
  width: 10vw;
  height: 46px;
  display: flex;
  gap: 10px;
}
.notificationsDropdown,
.mobileNotificationsDropdown {
  position: relative;
}
.notificationButton {
  position: relative;
  width: 46px;
  height: 46px;
  border-radius: 10px;
  border: none;
  background-color: #2f2f2f;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.mobileNotificationButton {
  background-color: #ffffff;
  border-color: #ffffff;
  color: #2f2f2f;
}
.notificationBadge {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 20px;
  height: 20px;
  border-radius: 999px;
  background-color: #ff8989;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
}
.notificationsList {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  width: 360px;
  max-width: min(360px, 85vw);
  max-height: 50vh;
  overflow-y: auto;
  background-color: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 14px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.12);
  padding: 16px;
  z-index: 6001;
}
.mobileNotificationsList {
  position: fixed;
  top: 84px;
  right: 16px;
  width: min(360px, calc(100vw - 32px));
}
.notificationsList > p {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
}
.notificationsList ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.notificationsList li {
  background-color: #f6fafd;
  border-radius: 12px;
  padding: 12px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.notificationIcon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background-color: #ffe2e2;
  color: #ff8989;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.notificationContent {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}
.notificationTitle {
  font-size: 14px;
  font-weight: 600;
  color: #2f2f2f;
}
.notificationText {
  font-size: 13px;
  line-height: 1.4;
  color: #5a5a5a;
}
.notificationDate {
  font-size: 11px;
  color: #8a8a8a;
}
.notificationsState {
  font-size: 14px;
  color: #757575;
  padding: 10px 0;
}
.userInfoName {
  font-size: 14px;
  color: #2f2f2f;
}
.userInfoID {
  font-size: 10px;
  color: #757575;
}
.mainMenu {
  padding: 13px;
  border-radius: 10px;
  background-color: #2f2f2f;
  border: 1px solid transparent;
  cursor: pointer;
  z-index: 5001;
  width: 46px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mainMenu svg {
  width: 24px;
}
.lowerHead {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  position: relative;
}
.headerCategories {
  display: flex;
  gap: 5%;
  justify-self: left;
  padding: 0px;
}
.headerCategories li {
  list-style-type: none;
  font-weight: 400;
  cursor: pointer;
  user-select: none;
}
.geoLocation {
  display: flex;
  gap: 5px;
  cursor: pointer;
}
.cityDropdown {
  justify-self: right;
  position: relative;
  z-index: 20;
}
.cityList {
  height: 50vh;
  width: 320px;
  max-width: min(320px, 80vw);
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fbfbfb;
  border: 1px solid #f4f4f4;
  border-radius: 10px;
  overflow-y: auto;
  padding: 2%;
  z-index: 6000;
}
.cityList::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

.cityList::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 8px;
}

.cityList::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 8px;
}

.cityList p {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 10px;
  margin-left: 15px;
}
.cityList ul {
  padding-left: 0;
  list-style-type: none;
}
.cityList ul li {
  color: black;
  cursor: pointer;
  user-select: none;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  gap: 5px;
}
@media (max-width: 968px) {
  .header {
    display: none;
  }
  .mobileHeader {
    display: flex;
  }
  .mobileAuthBlock {
    width: unset;
  }
  .headerCategories {
    display: flex;
    overflow-x: scroll;
    -ms-overflow-style: none; /* Для IE и старых версий Edge */
    scrollbar-width: none; /* Для Firefox */
    width: 90%;
    margin: 0 auto;
    margin-top: 3%;
  }
  .headerCategories li {
    background-color: #f6fafd;
    border-radius: 10px;
    color: #757575;
    padding: 5px 13px 5px 13px;
  }
  .upperHead {
    grid-template-columns: 1fr;
    margin: 0 auto;
    width: 80%;
  }
  .leftUpperHead {
    display: flex;
    justify-content: space-between; /* Это распределяет пространство между блоками */
    position: relative; /* Для контекста абсолютного позиционирования */
    align-items: center; /* Выравнивание элементов по вертикали */
    width: 100%;
  }
  .logoHeader {
    flex-grow: 1;
  }
  .lowerHead {
    display: block;
    z-index: 5000;
  }
  .mainMenu {
    width: 52px;
    height: 50px;
    padding: 10px 12px 10px 12px;
  }
  .signUp,
  .signIn {
    padding: 13px 10px 13px 10px;
    color: white;
    font-size: 14px;
  }
  .signIn {
    border: 1px solid white;
  }
  .geoLocation {
    color: white;
    position: absolute;
    right: 20px;
  }
  .cityDropdown {
    position: absolute;
    right: 20px;
    z-index: 5002;
  }
  .leftUpperHead {
    gap: 50px;
  }
  .profileSection {
    width: 100%;
  }
  .notificationsList {
    max-height: 60vh;
  }
  .geoLocation p {
    font-weight: 600;
  }
  .cityList {
    width: min(80vw, 340px);
    padding: 5%;
    overflow: hidden;
  }
}
</style>
